module.exports = __webpack_public_path__ + "img/cap-10.1fcbd29f.png";